import { Component, Input } from '@angular/core';
import { SvgIconComponent } from '../../form-elements/components/svg-icon/svg-icon.component';
import { NgIf } from '@angular/common';

@Component({
  selector: 'qvs-status-screen-banner',
  templateUrl: './status-screen-banner.component.html',
  styleUrls: ['./status-screen-banner.component.scss'],
  standalone: true,
  imports: [NgIf, SvgIconComponent]
})
export class StatusScreenBannerComponent {
  @Input() bannerSrc: string;
  @Input() iconSrc: string;
  @Input() rotate: boolean;
}
